import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { useState } from 'react';
import { PlayFill } from '@olist/design-system-icons';
import { Wrapper, StyledThumbnail, StyledPlay, StyledVideo } from './styles.js';
import objectToQueryString from '../../utils/objectToQueryString.js';
import { Box } from '../Box/Box.js';
import { Modal } from '../Modal/Modal.js';

const BASE_URL_IMAGE = 'https://img.youtube.com/vi';
const BASE_URL_VIDEO = 'https://www.youtube.com/embed';
const YoutubeVideoPlayer = (_a) => {
    var { children, videoId, thumbOption, onOpen, onClose, options, title } = _a, boxProps = __rest(_a, ["children", "videoId", "thumbOption", "onOpen", "onClose", "options", "title"]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const openModal = () => {
        onOpen();
        setIsOpenModal(true);
    };
    const closeModal = () => {
        onClose();
        setIsOpenModal(false);
    };
    const params = objectToQueryString(options, { rel: 0 });
    return (React.createElement(Wrapper, Object.assign({}, boxProps, { "data-testid": "youtube-embed" }),
        children && React.createElement(Box, { onClick: openModal }, children),
        !children && (React.createElement(StyledThumbnail, { src: `${BASE_URL_IMAGE}/${videoId}/${thumbOption}.jpg`, onClick: openModal },
            React.createElement(StyledPlay, null,
                React.createElement(PlayFill, { color: "white", width: 30, height: 40 })))),
        React.createElement(Modal, { isOpen: isOpenModal, onClose: closeModal, title: title, body: React.createElement(StyledVideo, { title: title, src: `${BASE_URL_VIDEO}/${videoId}?${params}` }) })));
};

export { YoutubeVideoPlayer as default };
